Core.ProductCompare = {
    init: function () {
        $('.icon-close').on('click', function () {

            var _$this = $(this),
                _classToDelete = _$this.parents('td').attr("class"),
                _table = _$this.parents('table'),
                _productCode = _$this.parents('td').attr("data-code");

            _table.find('.' + _classToDelete).remove();

            if (_table.find('tr').first().children().length === 1) {
                _table.remove();
                $('#compare-empty').show();
                $('#compareTools').hide();
            }
        });

        try {
            addthis.init();
        }
        catch (e) { }
    }
};